import { useState } from 'react';
import { LoadingBar } from '../../common/LoadingBar';
import { LoadingContext } from './LoadingContext';

export function LoadingProvider({ children }: { children: React.ReactNode }) {
  const [count, setCount] = useState(0);

  const increment = () => setCount((prev) => prev + 1);
  const decrement = () => setCount((prev) => prev - 1);

  return (
    <LoadingContext.Provider value={{ increment, decrement }}>
      <LoadingBar visible={count > 0} />
      {children}
    </LoadingContext.Provider>
  );
}
